import React from 'react';
import HeroSection from '../components/HeroSection';
import ServiceCard from '../components/ServiceCard';
import './OfficesPage.css';

function OfficesPage() {
  return (
    <div className="offices-page">
      <HeroSection
        backgroundImage="/images/hero_offices.jpg"
        title="Office Carpet Cleaning — Zero Disruption to Your Business"
        subtitle="Healthier, fresher workspaces that make the right impression on clients and improve staff wellbeing — cleaned entirely outside your working hours."
        ctaText="Get an Office Cleaning Quote"
        ctaLink="/contact"
      />

      {/* Value Propositions */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Built for the Modern Workplace</h2>
            <p>
              Office carpets take daily punishment — foot traffic, spills, and constant wear. 
              We restore them to a standard that reflects the professionalism of your business.
            </p>
          </div>
          <div className="grid grid--3">
            <ServiceCard
              icon="&#127970;"
              title="Open Plan Offices"
              description="Comprehensive cleaning for large workspaces — completed outside business hours so there's zero disruption to your team."
            />
            <ServiceCard
              icon="&#128188;"
              title="Executive Suites"
              description="Premium cleaning for boardrooms and executive offices where presentation standards are at their highest."
            />
            <ServiceCard
              icon="&#128682;"
              title="Reception Areas"
              description="Your reception is where first impressions are made. We keep it spotless and welcoming for every visitor."
            />
          </div>
        </div>
      </section>

      {/* Open Plan Image + Text */}
      <section className="section section--soft">
        <div className="container">
          <div className="split">
            <div className="split__image">
              <img
                src="/images/office_open_plan_clean.jpg"
                alt="Modern British open-plan office with pristine carpet"
              />
            </div>
            <div className="split__content">
              <h2>Maintain a Professional Workspace</h2>
              <p>
                Clean carpets aren't just about appearances — they improve indoor air quality, 
                reduce allergens, and create a healthier environment for your team.
              </p>
              <p>
                Our commercial-grade extraction equipment removes deep-seated dirt that 
                regular vacuuming misses, leaving carpets visibly refreshed and hygienically clean.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Boardroom Image + Text */}
      <section className="section">
        <div className="container">
          <div className="split split--reverse">
            <div className="split__image">
              <img
                src="/images/office_boardroom_pristine.jpg"
                alt="Upscale British corporate boardroom with immaculate dark carpet"
              />
            </div>
            <div className="split__content">
              <h2>Boardrooms That Impress</h2>
              <p>
                When clients walk into your boardroom, the condition of your carpet says 
                something about your business. We ensure it always says the right thing.
              </p>
              <p>
                Premium deep cleaning for executive spaces that demand the highest standards.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Evening Cleaning Feature */}
      <div
        className="image-break"
        style={{ backgroundImage: 'url(/images/evening_office_cleaning.jpg)' }}
      >
        <div className="image-break__overlay" />
        <div className="image-break__content">
          <h2>After-Hours Service, Ready at Short Notice</h2>
          <p>
            We clean when your office is empty — evenings, overnight, and weekends. 
            Your team arrives to fresh carpets without ever being disrupted. 
            And we can often start within 24 hours of your call.
          </p>
        </div>
      </div>

      {/* USP Highlights */}
      <section className="section">
        <div className="container">
          <div className="feature-highlights">
            <div className="feature-highlight">
              <div className="feature-highlight__icon">&#9790;</div>
              <h3 className="feature-highlight__title">Evenings &amp; Weekends</h3>
              <p className="feature-highlight__desc">
                We work entirely outside your business hours so your team never 
                loses a minute of productivity.
              </p>
            </div>
            <div className="feature-highlight">
              <div className="feature-highlight__icon">&#9889;</div>
              <h3 className="feature-highlight__title">Rapid Response</h3>
              <p className="feature-highlight__desc">
                Need it done fast? We can mobilise at short notice for urgent 
                cleans, spills, or pre-event turnarounds.
              </p>
            </div>
            <div className="feature-highlight">
              <div className="feature-highlight__icon">&#128203;</div>
              <h3 className="feature-highlight__title">Maintenance Contracts</h3>
              <p className="feature-highlight__desc">
                Scheduled cleaning that fits your budget and keeps your office 
                looking its best all year round.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Strong CTA */}
      <section className="sales-cta">
        <div className="container">
          <h2>Give Your Office the Clean It Deserves</h2>
          <p>
            Call now for a free, no-obligation quote. We'll build a cleaning plan 
            around your schedule and budget.
          </p>
          <a href="tel:+447887394404" className="sales-cta__phone">
            07887 394404
          </a>
          <button
            className="btn btn--accent btn--lg"
            onClick={() => window.location.href = '/contact'}
          >
            Or Request a Quote Online
          </button>
          <p className="sales-cta__sub">
            Same-day response guaranteed. Evening and weekend appointments available.
          </p>
        </div>
      </section>
    </div>
  );
}

export default OfficesPage;
